import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  http = inject(HttpClient);

  baseURL = environment.apiUrl + '/api/v1';

  constructor() {}

  saveRefreshToken(token: string) {
    localStorage.setItem('jwt_refresh_token', token);
  }

  saveToken(token: string) {
    localStorage.setItem('jwt_access_token', token);
  }

  getRefreshToken() {
    return localStorage.getItem('jwt_refresh_token');
  }

  getToken() {
    return localStorage.getItem('jwt_access_token');
  }

  getNewAccessToken() {
    return this.http.post(this.baseURL + '/refresh', {});
  }

  logout() {
    return this.http.post(this.baseURL + '/logout', {});
  }

  clearToken() {
    localStorage.removeItem('jwt_refresh_token');
    localStorage.removeItem('jwt_access_token');
  }
}
